// @ts-nocheck
import React from 'react'
import { Navigate } from 'react-router-dom'
import { BiWallet } from 'react-icons/bi'
import { IRoute } from 'src/models/navigation.model'

const AccountingAccount = React.lazy(
  () => import('src/pages/Accounting/Accounts'),
)
const AccountingAccountDetail = React.lazy(
  () => import('src/pages/Accounting/Detail'),
)
const AccountingTransactions = React.lazy(
  () => import('src/pages/Accounting/Transactions'),
)
const AccountingDashboard = React.lazy(
  () => import('src/pages/Accounting/Dashboard'),
)
const AccountingTransactionsDetail = React.lazy(
  () => import('src/pages/Accounting/Transactions/Detail'),
)
const AccountingAddTransactions = React.lazy(
  () => import('src/pages/Accounting/AddTransactions'),
)
const AccountingReports = React.lazy(
  () => import('src/pages/Accounting/Reports'),
)
const AccountingPostingMonitor = React.lazy(
  () => import('src/pages/Accounting/PostingMonitor'),
)
const AccountingAccountMappings = React.lazy(
  () => import('src/pages/Accounting/AccountMappings'),
)
const AccountingGuide = React.lazy(
  () => import('src/pages/Accounting/Guide'),
)
const AccountingOpeningBalance = React.lazy(
  () => import('src/pages/Accounting/OpeningBalance'),
)
const AccountingPeriodLocks = React.lazy(
  () => import('src/pages/Accounting/PeriodLocks'),
)

function AccountingHomeRedirect() {
  return <Navigate to="/accounting/dashboard" replace />
}

export const nav: IRoute[] = [
  {
    path: '',
    name: 'accounting',
    key: 'accounting',
    label: 'Accounting',
    component: null,
    children: [
      {
        path: '/accounting/dashboard',
        key: 'accounting-dashboard',
        label: 'nav.dashboard',
        component: AccountingDashboard,
      },
      {
        path: '/accounting/accounts',
        key: 'accounting-accounts',
        label: 'nav.accounts',
        component: AccountingAccount,
      },
      {
        path: '/accounting/transactions',
        key: 'accounting-transactions',
        label: 'nav.transactions',
        component: AccountingTransactions,
      },
      {
        path: '/accounting/reports',
        key: 'accounting-reports',
        label: 'nav.reports',
        component: AccountingReports,
      },
      {
        path: '/accounting/mappings',
        key: 'accounting-mappings',
        label: 'nav.accountMappings',
        component: AccountingAccountMappings,
      },
      {
        path: '/accounting/posting-monitor',
        key: 'accounting-posting-monitor',
        label: 'nav.postingMonitor',
        component: AccountingPostingMonitor,
      },
      {
        path: '/accounting/setup',
        key: 'accounting-setup',
        label: 'nav.accountingSetup',
        component: React.lazy(() => import('src/pages/Accounting/Setup')),
      },
      {
        path: '/accounting/opening-balances',
        key: 'accounting-opening-balances',
        label: 'nav.openingBalances',
        component: AccountingOpeningBalance,
      },
      {
        path: '/accounting/period-locks',
        key: 'accounting-period-locks',
        label: 'nav.closingPeriods',
        component: AccountingPeriodLocks,
      },
      {
        path: '/accounting/guide',
        key: 'accounting-guide',
        label: 'nav.financeGuide',
        component: AccountingGuide,
      },
    ],
    icon: <BiWallet size={16} />,
    isNav: true,
  },
]

export const routes: IRoute[] = [
  {
    path: '/dashboard',
    key: 'dashboard',
    label: 'Dashboard',
    component: AccountingHomeRedirect,
    children: [],
    isNav: false,
  },
  {
    path: '/accounting/dashboard',
    name: 'accounting-dashboard',
    key: 'accounting-dashboard',
    label: 'nav.dashboard',
    component: AccountingDashboard,
  },
  {
    path: '/accounting/accounts',
    name: 'accounting-accounts',
    key: 'accounting-accounts',
    label: 'nav.accounts',
    component: AccountingAccount,
  },
  {
    path: '/accounting/accounts/:id',
    name: 'accounting-accounts-detail',
    key: 'accounting-accounts-detail',
    label: 'Account Detail',
    component: AccountingAccountDetail,
  },
  {
    path: '/accounting/transactions',
    name: 'accounting-transactions',
    key: 'accounting-transactions',
    label: 'nav.transactions',
    component: AccountingTransactions,
  },
  {
    path: '/accounting/transactions/:id',
    name: 'accounting-transaction-detail',
    key: 'accounting-transaction-detail',
    label: 'Transaction Detail',
    component: AccountingTransactionsDetail,
  },
  {
    path: '/accounting/reports',
    name: 'accounting-reports',
    key: 'accounting-reports',
    label: 'nav.reports',
    component: AccountingReports,
  },
  {
    path: '/accounting/mappings',
    name: 'accounting-mappings',
    key: 'accounting-mappings',
    label: 'nav.accountMappings',
    component: AccountingAccountMappings,
  },
  {
    path: '/accounting/posting-monitor',
    name: 'accounting-posting-monitor',
    key: 'accounting-posting-monitor',
    label: 'nav.postingMonitor',
    component: AccountingPostingMonitor,
  },
  {
    path: '/accounting/setup',
    name: 'accounting-setup',
    key: 'accounting-setup',
    label: 'nav.accountingSetup',
    component: React.lazy(() => import('src/pages/Accounting/Setup')),
  },
  {
    path: '/accounting/opening-balances',
    name: 'accounting-opening-balances',
    key: 'accounting-opening-balances',
    label: 'nav.openingBalances',
    component: AccountingOpeningBalance,
  },
  {
    path: '/accounting/period-locks',
    name: 'accounting-period-locks',
    key: 'accounting-period-locks',
    label: 'nav.closingPeriods',
    component: AccountingPeriodLocks,
  },
  {
    path: '/accounting/guide',
    name: 'accounting-guide',
    key: 'accounting-guide',
    label: 'nav.financeGuide',
    component: AccountingGuide,
  },
  {
    path: '/accounting/transactions/add',
    name: 'accounting-add-transactions',
    key: 'accounting-add-transactions',
    label: 'Add Transactions',
    component: AccountingAddTransactions,
  },
  {
    path: '/accounting/transactions/edit/:id',
    name: 'accounting-edit-transactions',
    key: 'accounting-edit-transactions',
    label: 'Edit Transactions',
    component: AccountingAddTransactions,
  },
]

export const routes_ibo: IRoute[] = routes
